"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DoneIcon = function (_React$Component) {
    _inherits(DoneIcon, _React$Component);

    function DoneIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, DoneIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DoneIcon.__proto__ || Object.getPrototypeOf(DoneIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary) {
            return _react2.default.createElement(
                "svg",
                { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 24 24" },
                _react2.default.createElement("rect", { fill: "transparent", width: "24", height: "24" }),
                _react2.default.createElement("path", { d: "M19.826,1.84,7.352,14.314a.588.588,0,0,1-.836,0L.174,7.971a.588.588,0,0,1,0-.836L1,6.312a.588.588,0,0,1,.836,0l5.1,5.1L18.167.169a.6.6,0,0,1,.836,0L19.826,1a.588.588,0,0,1,0,.836Z", transform: "translate(2.002 4.686)", fill: primary })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DoneIcon, [{
        key: "render",
        value: function render() {
            var size = this.props.size || 24;
            return this.getIcon(size, size, this.props.color);
        }
    }]);

    return DoneIcon;
}(_react2.default.Component);

exports.default = DoneIcon;